module.exports = __webpack_public_path__ + "0714f2e7b09e249cfa78173844de9f57.svg";